/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BulkEventsArchiveResponse
 */
export interface BulkEventsArchiveResponse {
    /**
     * 
     * @type {number}
     * @memberof BulkEventsArchiveResponse
     */
    ok: number;
    /**
     * 
     * @type {number}
     * @memberof BulkEventsArchiveResponse
     */
    failed: number;
    /**
     * 
     * @type {Array<{ [key: string]: any; }>}
     * @memberof BulkEventsArchiveResponse
     */
    failures: Array<{ [key: string]: any; }>;
    /**
     * 
     * @type {boolean}
     * @memberof BulkEventsArchiveResponse
     */
    failuresTruncated: boolean;
}

/**
 * Check if a given object implements the BulkEventsArchiveResponse interface.
 */
export function instanceOfBulkEventsArchiveResponse(value: object): value is BulkEventsArchiveResponse {
    if (!('ok' in value) || value['ok'] === undefined) return false;
    if (!('failed' in value) || value['failed'] === undefined) return false;
    if (!('failures' in value) || value['failures'] === undefined) return false;
    if ((!('failuresTruncated' in (value as Record<string, any>)) && !('failures_truncated' in (value as Record<string, any>))) || ((value as Record<string, any>)['failuresTruncated'] === undefined && (value as Record<string, any>)['failures_truncated'] === undefined)) return false;
    return true;
}

export function BulkEventsArchiveResponseFromJSON(json: any): BulkEventsArchiveResponse {
    return BulkEventsArchiveResponseFromJSONTyped(json, false);
}

export function BulkEventsArchiveResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): BulkEventsArchiveResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'ok': json['ok'],
        'failed': json['failed'],
        'failures': json['failures'],
        'failuresTruncated': json['failures_truncated'],
    };
}

export function BulkEventsArchiveResponseToJSON(json: any): BulkEventsArchiveResponse {
    return BulkEventsArchiveResponseToJSONTyped(json, false);
}

export function BulkEventsArchiveResponseToJSONTyped(value?: BulkEventsArchiveResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'ok': value['ok'],
        'failed': value['failed'],
        'failures': value['failures'],
        'failures_truncated': value['failuresTruncated'],
    };
}

